import { css } from 'styled-components';
import { themeGet } from 'modules/tetrisTheme';
export const iconButtonBase = css `
  flex-shrink: 0;

  ${({ $round }) => $round &&
    `
    border-radius: ${themeGet('borderRadius.circle')};
  `}
`;
